import { render } from "./InboundList.vue?vue&type=template&id=bbb10122&scoped=true"
import script from "./InboundList.vue?vue&type=script&lang=js"
export * from "./InboundList.vue?vue&type=script&lang=js"

import "./InboundList.vue?vue&type=style&index=0&id=bbb10122&scoped=true&lang=css"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb10122"]])

export default __exports__